import React, { Component } from 'react';

//pages
import AreaRestrita from './../area-restrita/AreaRestrita';
import Login from './../login/Login';
import Erro404 from './../errors/Erro404';

//styles
import '../../styles/App.css';

// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

class App extends Component {
  constructor (props){
    super(props);
    window.LANGUAGE = 'pt_BR';
  }

  componentDidMount() {

  }

  componentWillUnmount() {
  }

  render() {
    return (
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/area-restrita" component={AreaRestrita} />
        <Route component={Erro404} />
      </Switch>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/classes/app/App.js